import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _JSXStyle from "styled-jsx/style";
import React from 'react';
import withDefaults from '../utils/with-defaults';
import useTheme from '../styles/use-theme';
var defaultProps = {
  className: ''
};

var ModalSubtitle = function ModalSubtitle(_ref) {
  var className = _ref.className,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "children"]);

  var theme = useTheme();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", _extends({}, props, {
    className: _JSXStyle.dynamic([["2362843847", [theme.palette.accents_5]]]) + " " + (props && props.className != null && props.className || className || "")
  }), children), /*#__PURE__*/React.createElement(_JSXStyle, {
    id: "2362843847",
    dynamic: [theme.palette.accents_5]
  }, "p.__jsx-style-dynamic-selector{font-size:0.875rem;line-height:1.6;font-weight:normal;text-align:center;margin:0;display:-webkit-inline-box;display:-webkit-inline-flex;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;word-break:break-word;text-transform:uppercase;color:".concat(theme.palette.accents_5, ";}")));
};

var MemoModalSubtitle = React.memo(ModalSubtitle);
export default withDefaults(MemoModalSubtitle, defaultProps);